export const MessageSection = ({ theme }) => `
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 60px 85px 32px 85px;
  margin: auto;
  box-sizing: border-box;
  border-radius: 10px;
  width: 539px;
  max-height: 499px;
  background: white;
  box-shadow: 0px 4px 12px -4px rgb(22 34 51 / 12%), 0px 16px 32px rgb(22 34 51 / 16%);
  
  
  @media screen and ${theme.device.max.laptopS} {
    max-height: 420px;
    width: 300px;
    padding: 0;
    background: none;
    box-shadow: none;
    .message-card-title, .message-card-subtitle {
      color: white;
    }
  }

  > .card-content {
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  .header-image {
    width: 169px;
    height: 166px;
    margin: 40px 0;
  }
  
  .message-card-title {
    font-size: 21px;
    line-height: 32px;
    margin-bottom: 32px;
  }
`;
